const dictionary = {
  copyright: "All Rights Reserved.",
  cancel: "Cancel",
  submit: "Submit",
  reject: "Reject",
  accept: "Accept",
  "update-contact-info": "Update your contact information here.",
  logout: "Log Out",
  profile: "Profile",
  delegation: "Partnership",
  agree: "I agree",
  users: "Users",
  "user-cases": "Listings",
  "connection-error": "Connection error, please try again later.",
  search: "Search",
  edit: "Edit",
  delete: "Delete",
  user: "Citizen",
  lawyer: "Attorney",
  admin: "Admin",
  agent: "Moderator",
  premium: "Premium",
  "create-date": "Creation Date",
  selected: "Selected",
  approve: "Approve",
  confirm: "Confirm",
  abort: "Abort",
  error: "Your transaction could not be completed. Please try again later.",
  success: "Your transaction was successful.",
  "rows-per-page": "Items per page",
  active: "Active",
  deactive: "Deactivated",
  pending: "Pending Approval",
  rejected: "Rejected",
  on_hold: "On Hold",
  homepage: "Homepage",
  save: "Save",
  update_contact_info: "Please update your contact info before proceeding.",
  review: "Review",
  "my-cases": "My Listings",
  "my-offers": "My Offers",
  "incoming-offers": "Offers Received",
  "has-no-offer": "You don’t have any offers yet.",
  "contact-us": "Contact Us",
  "privacy-policy": "Privacy Policy",
  faq: "FAQ",
  "how-to": "How To",
  "app-require-online": "This application requires an internet connection.",

  // Login
  login: "Login",
  register: "Register",
  forgotPassword: "Forgot Password",
  email: "Email",
  "email-required": "Email is required.",
  "email-pattern": "Invalid email format, please enter a valid email.",
  password: "Password",
  changePassword: "Update Password",
  "password-required": "Password is required.",
  googleLogin: "Login with Google",
  googleRegister: "Register with Google",
  signInWithApple: "Sign in with Apple",
  fpSuccess:
    "Password reset link has been sent to your email. Please check your inbox.",
  fpError:
    "An error occurred while processing your request. Please try again later.",
  enterCaptcha: "Please enter the verification code.",
  captchaError: "Please complete the captcha verification.",
  captchaFetchError:
    "An error occurred while fetching the verification code, please try again later.",
  loginError: "Incorrect email or password.",
  userExists: "An account with this email already exists.",
  userBlocked: "Your account has been blocked.",
  enterVerificationCode:
    "Please enter the verification code sent to your email:",
  verificationFailed: "Verification failed.",
  registerSuccess: "Your account has been created. You may now log in.",
  userAgreementAccept:
    "I have read, understood and agree to the user agreement.",
  userNotExists: "No account found with this email, please register first.",
  userAlreadyExists:
    "An account with this email already exists, please log in instead.",
  invalidCaptcha: "Invalid verification code, please try again.",
  invalidEmail: "Invalid email address, please try again.",

  // Forgot Password
  "reset-password": "Reset Password",
  "new-password": "Enter your new password:",
  "new-password-validate": "Re-enter your new password:",
  "invalid-hash": "Invalid code",
  "new-password-not-valid": "Password must be between 6 and 50 characters.",
  "new-password-not-comply":
    "Passwords do not match. Please retype for verification.",
  "reset-successful":
    "Your password has been successfully reset. You may now log in.",

  // Homepage
  "search-post": "Search post...",
  "new-case": "New Case",
  "new-delegation": "New Partnership",
  "open-cases": "Your Open Cases",
  budget: "Budget",
  "greet-lawyer":
    'Hello {0}! You don’t have any partnerships yet, <a href="/delegation/new">click here</a> to create one.',
  "greet-user":
    'Hello {0}! You don’t have any posts yet, <a href="/case/new">click here</a> to create one.',
  "are-you-lawyer":
    'Are you a lawyer? <a href="/profile">You can apply from your profile page here.</a>',
  "most-used-case-categories": "Most used case categories",
  "most-offered-cases": "Most offered cases",
  "most-hand-shake-cases": "Cases with agreements",
  "see-more-cases": "You have {0} more cases, click to view.",
  "your-offers": "Your Offers",
  "your-cases": "Your Cases",
  "your-partnerships": "Your Partnerships",

  // Profile
  "your-profile": "Your Profile Information",
  "user-id": "User ID",
  "first-name": "First Name",
  "last-name": "Last Name",
  "profile-email-pattern": "Please enter a valid email address.",
  "profile-email-required": "Email is required.",
  "phone-number": "Phone Number",
  "profile-phone-pattern": "Please enter a valid phone number.",
  "profile-phone-required": "Phone number is required.",
  "profile-first-name-pattern": "Please enter a valid first name.",
  "profile-first-name-required": "First name is required.",
  "profile-first-name-maxLength": "First name must not be too long.",
  "profile-last-name-pattern": "Please enter a valid last name.",
  "profile-last-name-required": "Last name must not be too long.",
  "user-saved": "Your information has been saved.",
  "user-save-failed": "Failed to save your information, please try again.",
  "lawyer-registration-info":
    "If you are registered with a bar, you can fill in these fields.",
  "lawyer-bar-info": "Approved bar details:",
  "lawyer-pending-info": "Your application is under review.",
  "bar-no": "Bar Number",
  "bar-no-minLength": "Bar number must be 5 digits.",
  "bar-no-maxLength": "Bar number must be 5 digits.",
  "bar-no-validate": "Bar number and name must be provided together.",
  "bar-name": "Bar Name",
  "bar-name-minLength": "Bar name must be at least 10 letters.",
  "bar-name-maxLength": "Bar name must not exceed 100 characters.",
  "bar-name-validate": "Bar number and name must be provided together.",
  "bar-name-pattern": "Bar name must contain letters only.",
  "profile-roles-validate":
    "Bar number and name are required for the lawyer role.",
  "enter-code": "Enter the code here",
  "send-code": "Send Code",
  "validate-code": "Verify Code",
  "wrong-code": "Incorrect Code!",
  "lawyer-sign-up": "Apply",
  "id-photos": "ID Photos (Front and Back)",
  "id-photos-rules":
    "Please upload the front and back sides of your bar association ID in 'jpg' format. The file size must not exceed {0} KB.",
  "id-photos-size-error": "File size must not exceed {0} KB.",
  "id-photos-missing":
    "Please select two photos of your ID (front and back) to apply as a lawyer.",
  "lawyer-application": "Lawyer Application",
  "select-file": "Select File",
  "doc-save-failed": "Document upload failed, please try again later.",
  "lawyer-application-success":
    "Your lawyer application has been submitted. Please wait for approval.",
  "lawyer-application-legal-warning":
    "Legal Notice for Lawyer Application: <br/><br/> By registering here, you request to be added to the system as a lawyer. With this application, you declare that you are a lawyer registered with the Union of Turkish Bar Associations. Your identification documents will also be requested. If all conditions are met, your profile currently marked as a citizen will be updated as a lawyer. You bear full legal and criminal responsibility for the accuracy of the information provided. <br/><br/> By completing your application, you are deemed to have accepted this responsibility.",
  lawyerAgreementAccept: "I accept the above obligations and responsibilities.",
  "deactivate-user": "Remove Account",
  "deactivate-user-info": `
    By removing your account, all your listings will be stopped and your offers will be closed.
    Other users will no longer be able to view your listings and offers.
    You will need to register again with your email address associated with your account when you want to log in.
    <br/><br/>
    Are you sure you want to remove your account?
  `,
  "user-deactivated": "Your account has been removed.",
  "user-deactivate-failed": "Account removal failed, please try again later.",

  // Notifications
  notifications: "Notifications",
  new_offer_title: "New offer received",
  new_offer_description: "You received an offer for your listing no. {0}.",
  "mark-as-read": "Mark as read",
  offer_accepted_title: "Your offer has been accepted",
  offer_accepted_description:
    "The offer you made for listing no. {0} has been accepted by the listing owner. You can find the owner's contact details in the offers section.",
  offer_rejected_title: "Your offer has been rejected",
  offer_rejected_description:
    "The offer you made for listing no. {0} has been rejected, you can review the details on the offers page.",
  offer_published_title: "Your offer has been submitted",
  offer_published_description:
    "The offer you made for listing no. {0} has been submitted successfully. You can wait for a reply from listing owner now.",
  case_approved_title: "Your listing has been approved",
  case_approved_description:
    "Listing no. {0} has been published. Registered lawyers can view and submit offers.",
  case_rejected_title: "Your listing has been rejected",
  case_rejected_description:
    "Listing no. {0} has been rejected. You can review the rejection reason in your profile.",
  lawyer_application_approved_title:
    "Your lawyer application has been approved",
  lawyer_application_approved_description:
    "Congratulations, you can now view listings and submit offers.",
  lawyer_application_rejected_title:
    "Your lawyer application has been rejected",
  lawyer_application_rejected_description:
    "Sorry, you need to meet the following requirements to become a lawyer: {2}",

  // Cases
  "pending-cases": "Pending cases",
  "rejected-cases": "Rejected cases",
  "inactive-cases": "Inactive cases",
  "on-hold-cases": "On-hold cases",
  "more-case-with-premium":
    "Your posting limit is {0}. Upgrade to premium to post more cases.",
  "your-case-limit": "You have a total of {0} case posting rights.",

  // CaseItem Details
  case: "Case",
  "case-code": "Case Code",
  "missing-case-id-in-url":
    "Case information could not be retrieved. Case ID is missing in the URL.",
  "case-category-selection": "Topic",
  "please-select-main-category": "Please select a service type",
  "please-select-sub-category": "Please select a subject of service",
  "main-category-info":
    "Dear user, according to our laws, LAWYERS can handle all legal matters. However, they have the right to choose. It is also observed that many lawyers tend to specialize in certain topics. For this reason, choosing the correct topic will help you reach specialized lawyers faster. We have divided topics into three main branches: Criminal, Civil, and Others. Each includes subcategories for easier selection. Please make your choices carefully. Our expert moderators will review and verify your preferences. Inaccurate or inappropriate listings will be corrected or removed.",
  back: "Back",
  next: "Next",
  "case-city-selection": "Location",
  "please-select-case-city": "Case Province",
  "please-select-user-city": "Your Province",
  "case-description": "Description",
  "please-enter-short-desc": "Please enter a brief description of your problem",
  "please-enter-long-desc": "Would you like to provide detailed information?",
  "please-write-here": "Write here",
  "please-write-category": "Type down the topic you are looking for...",
  summary: "Summary",
  "please-review-case-details": "Entered Information",
  "case-type": "Main Case Category",
  "case-sub-type": "Sub Case Category",
  "case-city": "Case City (Court)",
  "user-city": "Plaintiff City",
  "case-short-desc": "Short Description",
  "case-long-desc": "Detailed Description",
  "upgrade-to-premium": "Upgrade to Premium",
  "short-desc-required":
    "Please enter a short description of at least 50 characters",
  "short-desc-minLength": "Keep writing until you reach at least 50 characters",
  "short-desc-maxLength": "You can enter up to 500 characters",
  "budget-required": "Please enter a price",
  "budget-min": "The entered amount must be at least 100",
  "give-offer": "Submit Offer",
  "lawyer-offer-text":
    "Please enter at least 50 characters of explanation for your potential client...",
  "min-offer-price-error": "The minimum amount you can enter is: {0}",
  "empty-offer-description-error": "Please write a short description",
  "lawyer-description-legal-warning-header":
    "Please read and confirm the following text:",
  "lawyer-description-legal-warning":
    "Legal Notice for Lawyers <br/> You can enhance your offer by briefly introducing yourself. Offers containing legal advice, or violating our Membership Agreement and the law will not be accepted. By clicking send, you accept that you are solely responsible for your offer content.",
  "type-more-with-premium": "Switch to premium to use more characters",
  "max-char-reached": "You have reached the character limit",
  "more-offers-with-premium":
    "You have used {0}/{1} offer rights. Upgrade for unlimited offers!",
  "see-offers": "View Offers ({0})",
  "contact-choice": "Contact Preference",
  contact: "Contact",
  "case-saved":
    "Your case has been submitted. It will be published after the necessary checks.",
  "please-select-one-contact-choice": "Please select at least one option",
  EMAIL: "Email",
  PHONE: "Phone",
  IN_PERSON: "In Person",
  "change-short-desc": "You can edit the description here:",
  "low-budget": "Low (₺)",
  "mid-budget": "Medium (₺₺)",
  "high-budget": "High (₺₺₺)",
  "unset-budget": "Prefer not to specify",
  kvkk: `I declare, accept, and undertake that:<br/><br/>• This notice and its content are in accordance with the "Vekilet Membership Agreement" approved by me during the membership application and all relevant laws and regulations.<br/><br/>• I consent to the publication of the information I provided in the scope of the case on the site with my approval.<br/><br/>• I accept full legal and penal responsibility for the content provided in this notice.<br/><br/>• The site owner is not liable for the content I personally prepared and submitted.<br/><br/>By confirming this text, I accept, declare, and undertake all these points.`,
  "description-info":
    'Dear user, in this section, please provide a summary that explains your legal issue. Do not share any information that may be criminal or negatively affect your legal case.<br/><br/>Please write clearly and concisely.<br/><br/>Example:<br/>"The tenant in my property rented in May 2019 has not paid rent for 6 months. I want support from a lawyer specialized in this issue."<br/><br/>Details can be discussed with the lawyers who contact you.<br/>Your preferences will be reviewed and validated by our experts. Inappropriate or incomplete submissions will be revised or removed.',
  "budget-info":
    "Dear user, by indicating the budget you can allocate for legal assistance, you may reach a suitable lawyer more quickly.",
  "contact-info":
    "Dear user, in this section, you can specify your communication preferences and indicate through which channels you want lawyers whose offers you accepted to contact you.",
  "deactivation-warning":
    "When you deactivate your case, you will lose all offers made to it. Do you still want to proceed?",

  // Delegation Details
  city: "City",
  district: "District",
  "please-select-city": "Please select a city",
  "please-select-district": "Please select a district",
  "please-enter-short-desc-lawyer":
    "Please enter a description for your colleagues",
  delegationAgreement: `Dear attorney user; You can publish an announcement in order to carry out your works, for which you have the power of attorney, together with our other colleagues, with the application for "Partnership Announcement". We would like to remind you of the professional responsibility principles regarding the partnership announcements, and you accept and declare that you have the obligation to ensure that the announcements you will make comply with the Law on Attorneys as well as the Constitution and all laws and regulations, and that in case of violation, all legal and criminal liability will be yours after the publication request of this announcement is sent.`,

  // CaseItem Search
  "no-search-result":
    "No results found matching your search criteria. Please try different keywords.",
  "order-by": "Sort by",
  "filter-by": "Filter by",
  budgetAsc: "Budget ↑",
  budgetDesc: "Budget ↓",
  createDateAsc: "Creation Date ↑",
  createDateDesc: "Creation Date ↓",
  userProvinceAsc: "City ↑",
  userProvinceDesc: "City ↓",
  caseTypeAsc: "Case Type ↑",
  caseTypeDesc: "Case Type ↓",

  // Lawyer Summary
  "citizen-cases": "Citizen Cases",
  "lawyer-cases": "Lawyer Delegation Cases",
  "see-more-cases-lawyer": "See more cases...",
  "lawyer-offer-info": "Please select a price range for your client",
  "open-offers": "Pending Offers",
  "new-offer": "offers not published yet.",
  "approved-offers": "Approved Offers",
  "rejected-offers": "Rejected Offers",
  "on-hold-offers": "On-Hold Offers",
  "see-more-offers": "Click to view your other offers",

  // OfferItem
  "offer-for-this-case": "You are evaluating the offer for this case",
  "lawyer-message": "Lawyer's message",
  offers: "Offers",
  "no-offer-for-case": "No offers for this case yet",
  "phone-required-to-accept-offer":
    "A registered phone number is required to accept offers",
  "you-rejected-offer": "You rejected the offer",
  "offer-on-hold":
    "This offer is on hold because you started an agreement with another offer",
  "start-agreement": "Start agreement",
  "started-agreement":
    "You started an agreement for this offer. Your contact details have been shared with the lawyer. You may cancel the agreement and consider other offers within 2 weeks. Otherwise, the case will be automatically closed.",
  "abort-agreement": "Cancel agreement",
  "bar-number": "Bar Number",
  "no-client-action": "The client has not evaluated any offers yet",
  "your-offer": "Your offer",
  "your-offer-sent": "Your offer has been sent",
  "your-offer-rejected": "Your offer has been rejected",
  "client-on-hold-offer":
    "This offer is on hold because the client has started an agreement with another offer. If the agreement is canceled, this offer will be re-evaluated.",
  "client-reject-offer": "The client rejected your offer",
  "client-accepted-offer": "The client accepted your offer",
  "client-preferred-contact": "Client's preferred contact information",
  "client-information": "Client information",
  "confirm-offer-approve":
    "Warning: After accepting the offer, your contact details will be shared with the offer owner and you won't be able to cancel the offer for 2 days. Do you confirm?",
  user_approved_other_offer: "The case owner is evaluating another offer",

  // Admin
  documents: "Documents",
  "please-type-keyword": "Please type a keyword into the search field",
  "no-result": "No results found",
  "admin-panel": "Admin Panel",
  "approval-pending-cases": "Pending Cases for Approval",
  "select-cases-to-process": "Select cases to process",
  "case-owner": "Case Owner",
  "approve-selected-cases": "Are you sure you want to approve these cases?",
  "reject-selected-cases": "Please provide a brief reason for rejection",
  "reject-reason": "Rejection Reason",
  "reject-reason-minlength": "Please enter at least 10 characters",
  "reject-reason-maxlength": "Do not enter more than 100 characters",
  block: "Block",
  unblock: "Unblock",
  activate: "Publish",
  deactivate: "Stop",
  "activate-user": "Activate",
  "approval-pending-lawyers": "Pending Lawyer Applications",
  "user-roles": "User Roles",

  // Premium
  subscribePremiumNow: "Upgrade to Premium Now",
  premiumPageTitle: "Switch to Premium Now!",
  premiumPageSubtitle:
    "Dear lawyer, by paying a small fee you can give more offers without limitations and reach more clients.",
  creditCardInformation: "Credit Card Information",
  cardHolderName: "Cardholder's Name",
  cardNumber: "Card Number",
  expirationMonth: "Month",
  expirationYear: "Year",
  cvv: "Security Code (CVV)",
  "card-holder-required": "This field is required",
  "card-holder-minLength": "Please enter at least 6 characters",
  "card-holder-maxLength": "You can enter up to 60 characters",
  "card-holder-pattern": "Please use only letters",
  "card-number-required": "This field is required",
  "card-number-minLength": "Please enter a 16-digit card number",
  "card-number-maxLength": "Card number must be 16 digits",
  "card-number-pattern": "Please enter only digits",
  "expiration-month-required": "This field is required",
  "expiration-month-minLength": "Please enter a 2-digit month",
  "expiration-month-maxLength": "Month must be 2 digits",
  "expiration-month-pattern": "Please enter only digits",
  "expiration-month-max": "Month cannot exceed 12",
  "expiration-month-min": "Month must be at least 01",
  "expiration-year-required": "This field is required",
  "expiration-year-minLength": "Please enter a 4-digit year",
  "expiration-year-maxLength": "Year must be 4 digits",
  "expiration-year-pattern": "Please enter only digits",
  "cvv-required": "This field is required",
  "cvv-minLength": "Please enter the 3-digit CVV code on the back of your card",
  "cvv-maxLength": "CVV code must be 3 digits",
  "cvv-pattern": "Please enter only digits",
  "make-payment": "Make Payment",

  // CaseItem Categories
  "c-1": "Criminal Cases",
  "c-2": "Private and Public Law Cases",
  "c-3": "Other Proceedings and Foreign Affairs",
  "c-1-b-1": "Criminal Court of First Instance",
  "c-1-b-2": "High Criminal Court",
  "c-1-b-3": "Prosecutor Investigations",
  "c-2-b-1": "Family Law",
  "c-2-b-2": "Commercial Law",
  "c-2-b-3": "Civil Court of Peace",
  "c-2-b-4": "Cadastral Court",
  "c-2-b-5": "Consumer Court",
  "c-2-b-6": "Labor Court",
  "c-2-b-7": "Civil Court of First Instance",
  "c-2-b-8": "Intellectual Property Court",
  "c-2-b-9": "Other",
  "c-2-b-10": "Administrative Lawsuits",
  "c-3-b-1": "Foreign Citizen Procedures",
  "c-3-b-2": "Consultancy",
  "c-3-b-3": "Enforcement",
  "c-1-b-1-s-1": "Theft",
  "c-1-b-1-s-2": "Sexual Crimes",
  "c-1-b-1-s-3": "Insult",
  "c-1-b-1-s-4": "Threat",
  "c-1-b-1-s-5": "Injury",
  "c-1-b-1-s-6": "Property Damage",
  "c-1-b-1-s-7": "Fraud",
  "c-1-b-1-s-8": "Abuse of Trust",
  "c-1-b-1-s-9": "Drug Use / Possession",
  "c-1-b-1-s-10": "Forgery",
  "c-1-b-1-s-11": "Cybercrime",
  "c-1-b-1-s-12": "Other",
  "c-1-b-2-s-1": "Drug Trafficking",
  "c-1-b-2-s-2": "Organized Crime",
  "c-1-b-2-s-3": "Forgery",
  "c-1-b-2-s-4": "Sexual Crimes",
  "c-1-b-2-s-5": "Robbery",
  "c-1-b-2-s-6": "Smuggling",
  "c-1-b-2-s-7": "Homicide",
  "c-1-b-2-s-8": "Other",
  "c-1-b-3-s-1": "Suspect in Custody",
  "c-1-b-3-s-2": "Suspect Not in Custody",
  "c-1-b-3-s-3": "Complaint Submission",
  "c-2-b-1-s-1": "Inheritance",
  "c-2-b-1-s-2": "Divorce",
  "c-2-b-1-s-3": "Guardian / Trustee Appointment",
  "c-2-b-1-s-4": "Alimony",
  "c-2-b-1-s-5": "Custody",
  "c-2-b-1-s-6": "Restraining Order & Precautionary Measures",
  "c-2-b-1-s-7": "Other",
  "c-2-b-2-s-1": "Debt Recovery",
  "c-2-b-2-s-2": "Other",
  "c-2-b-3-s-1": "Rental Disputes",
  "c-2-b-3-s-2": "Site/Apartment Management",
  "c-2-b-3-s-3": "Dissolution of Co-ownership",
  "c-2-b-3-s-4": "Other",
  "c-2-b-4-s-1": "Cadastral Court",
  "c-2-b-5-s-1": "Debt Recovery",
  "c-2-b-5-s-2": "Compensation",
  "c-2-b-5-s-3": "Arbitration Board Application",
  "c-2-b-5-s-4": "Other",
  "c-2-b-6-s-1": "Employee Claims",
  "c-2-b-6-s-2": "Compensation",
  "c-2-b-6-s-3": "Reinstatement",
  "c-2-b-6-s-4": "Other",
  "c-2-b-7-s-1": "Real Estate Disputes",
  "c-2-b-7-s-2": "Debt Recovery",
  "c-2-b-7-s-3": "Other",
  "c-2-b-8-s-1": "Trademark, Patent, etc. Lawsuits",
  "c-2-b-9-s-1": "Other",
  "c-2-b-10-s-1": "Administrative Decision Annulment Lawsuits",
  "c-2-b-10-s-2": "Administrative Compensation Lawsuits",
  "c-2-b-10-s-3": "Other",
  "c-2-b-10-s-4": "Tax Lawsuits",
  "c-3-b-1-s-1": "Citizenship Procedures",
  "c-3-b-1-s-2": "Residency Permit Procedures",
  "c-3-b-1-s-3": "Work Permit Procedures",
  "c-3-b-1-s-4": "Deportation Objection Procedures",
  "c-3-b-1-s-5": "Visa Procedures",
  "c-3-b-1-s-6": "Consultancy Procedures",
  "c-3-b-1-s-7": "Other",
  "c-3-b-2-s-1": "Verbal (Meeting-Based) Consultancy",
  "c-3-b-2-s-2": "Written (Document Preparation) Consultancy",
  "c-3-b-2-s-3": "Mediation Representation",
  "c-3-b-2-s-4": "Other",
  "c-3-b-3-s-1": "Creditor Representation",
  "c-3-b-3-s-2": "Debtor Representation",
  "c-3-b-3-s-3": "Other",
};

export default dictionary;
